// frontend/src/pages/ForgotPassword.jsx
import { useState } from 'react';
import { passwordResetApi } from '../utils/api';
import toast from 'react-hot-toast';
import BrandIcon from '../components/BrandIcon';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await passwordResetApi.forgot(email);
      // Toujours un message de succès, que l'email existe ou non côté
      // serveur — évite de laisser deviner quels emails sont enregistrés.
      setSent(true);
    } catch {
      toast.error('Une erreur est survenue, réessayez.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg-base)' }}>
      <div style={{ width:'100%', maxWidth:400, padding:'0 16px' }}>
        <div style={{ textAlign:'center', marginBottom:40 }}>
          <div style={{ display:'flex', justifyContent:'center', marginBottom:12 }}><BrandIcon size={52}/></div>
          <h1 style={{ fontSize:24, fontWeight:700, background:'linear-gradient(135deg,var(--accent-light),var(--teal))', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            Mot de passe oublié
          </h1>
          <p style={{ color:'var(--text-2)', marginTop:6, fontSize:14 }}>
            Indiquez votre email, on vous envoie un lien de réinitialisation.
          </p>
        </div>

        {sent ? (
          <div className="card" style={{ padding:28, textAlign:'center' }}>
            <div style={{ fontSize:32, marginBottom:10 }}>✓</div>
            <p style={{ fontSize:14, color:'var(--text-2)', marginBottom:20 }}>
              Si un compte existe avec cet email, un lien de réinitialisation vient de lui être envoyé.
              Vérifiez votre boîte de réception (et vos spams).
            </p>
            <a href="/login" className="btn btn-secondary" style={{ display:'inline-flex' }}>Retour à la connexion</a>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div className="card" style={{ padding:28 }}>
              <div className="form-group" style={{ marginBottom:0 }}>
                <label className="form-label">Email</label>
                <input className="input" type="email" value={email} onChange={e=>setEmail(e.target.value)}
                  required placeholder="votre@email.fr" autoFocus />
              </div>
            </div>
            <button className="btn btn-primary w-full" disabled={loading} style={{justifyContent:'center', padding:'13px'}}>
              {loading ? <span className="spinner" style={{width:18,height:18}} /> : 'Envoyer le lien'}
            </button>
          </form>
        )}

        <p style={{ textAlign:'center', marginTop:24, fontSize:13, color:'var(--text-3)' }}>
          <a href="/login" style={{ color:'var(--teal)' }}>← Retour à la connexion</a>
        </p>
      </div>
    </div>
  );
}
